import { CalendarYear, PropsGetterConfig } from '@rehookify/datepicker';
import React from 'react';
import { getYearsClassName } from '../../date-time.utils';
import { TPropsGetters } from '../../date-time.types';
import { YearPanelSC } from './year-panel.styled';

interface YearPanelProps {
  years: CalendarYear[];
  yearButton: TPropsGetters['yearButton'];
  config?: PropsGetterConfig;
}

const YearPanel: React.FunctionComponent<YearPanelProps> = ({ yearButton, years, config }) => {
  return (
    <YearPanelSC>
      {years.map((year) => (
        <button className={getYearsClassName(year)} key={year.value} {...yearButton(year, config)}>
          {year.value}
        </button>
      ))}
    </YearPanelSC>
  );
};

export default YearPanel;
